import FingerprintJS from '@fingerprintjs/fingerprintjs'

let fpPromise = null

export const getFingerprint = async () => {
  if (!fpPromise) {
    fpPromise = FingerprintJS.load()
  }

  const fp = await fpPromise
  const result = await fp.get()

  if (!result.components) {
    return result
  }

  const { canvas, ...restComponents } = result.components

  return {
    ...result,
    components: restComponents,
  }
}



// WEBPACK FOOTER //
// ./src/modules/shared/services/fingerpring/index.js